import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import type { Car } from '@/api/cars/types';
import { client, throwFriendlyApiError } from '@/api/common';

type Variables = {};
export type ConnectStandardFleetResponse = {
  data: Car[];
};

export const useConnectStandardFleet = createMutation<
  ConnectStandardFleetResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: `v2/internal/partners/cars/standard-fleet/connect`,
      method: 'POST',
    })
      .then((response) => response.data)
      .catch((err: any) => throwFriendlyApiError(err, 'connect cars')),
});
